<script>
import Layout from "@/router/layouts/auth";
import Languages from "@/components/widgets/languages";
import EcosystemUserMenu from "@/components/widgets/ecosystem-user-menu";
import { api } from "@/state/services";
import { VMoney } from "v-money";

// Fatura do Tripteev: PIX e cartão pelos endpoints da loja (store/orders/:id/...)
export default {
  locales: {
    pt: {
      'Back': 'Voltar',
      'We apologize, we are unable to retrieve the invoice at this time.': 'Pedimos desculpas, não podemos recuperar a fatura neste momento.',
      'Try again': 'Tentar novamente',
      'The invoice was not found.': 'A fatura não foi encontrada.',
      'Back to Tripteev': 'Voltar ao Tripteev',
      'Pay your invoice': 'Pague sua fatura',
      'Choose the payment method. Access is released as soon as the payment is confirmed.': 'Escolha a forma de pagamento. O acesso é liberado assim que o pagamento for confirmado.',
      'Invoice': 'Fatura',
      'AWAITING PAYMENT': 'AGUARDANDO PAGAMENTO',
      'Charge': 'Cobrança',
      'Membership': 'Adesão',
      'Monthly fee': 'Mensalidade',
      'Plan': 'Plano',
      'Access': 'Acesso',
      '30 days': '30 dias',
      'Generated on': 'Gerada em',
      'Expires on': 'Vence em',
      'Total': 'Total',
      'Total paid:': 'Total pago:',
      'of': 'de',
      'Remaining:': 'Restante:',
      'Payment method': 'Forma de pagamento',
      'No payment method available at the moment. Please try again shortly.': 'Nenhuma forma de pagamento disponível no momento. Tente novamente em instantes.',
      'Credit Card': 'Cartão de Crédito',
      'Payment received': 'Pagamento recebido',
      'We are activating your access. This takes a few moments.': 'Estamos ativando o seu acesso. Isso leva poucos instantes.',
      'Access activated!': 'Acesso ativado!',
      'Your Tripteev access is valid from': 'Seu acesso ao Tripteev vale de',
      'to': 'a',
      'or': 'ou',
      'Sign in with your Nexteev username and password': 'Acesse com seu usuário e senha Nexteev',
      'Go to': 'Ir para',
      'Access the Tripteev portal': 'Acessar o portal Tripteev',
      'Invoice canceled': 'Fatura cancelada',
      'This invoice has been canceled or has expired. Go back to Tripteev to generate a new one.': 'Esta fatura foi cancelada ou expirou. Volte ao Tripteev para gerar uma nova.',

      'Amount to pay': 'Valor a pagar',
      'max:': 'máx:',
      'min:': 'mín:',
      'Generate Pix': 'Gerar Pix',
      'Use the QR code to proceed with the transaction.': 'Use o código QR para prosseguir com a transação.',
      'Or use Pix Copy and Paste to proceed with the transaction.': 'Ou utilize o Pix Copia e Cola para prosseguir com a transação.',
      'Use Pix Copy and Paste to proceed with the transaction.': 'Use o Pix Copia e Cola para prosseguir com a transação.',
      'Copy Pix Copy and Paste': 'Copiar Pix Copia e Cola',
      'Copied to clipboard.': 'Copiado para a área de transferência.',
      'Now, all you need to do is access your bank app and complete the process using Pix Copy and Paste.': 'Agora, tudo o que você precisa fazer é acessar o aplicativo do seu banco e concluir o processo usando o Pix Copia e Cola.',
      'Waiting for payment confirmation…': 'Aguardando a confirmação do pagamento…',
      'History': 'Histórico',
      'View': 'Ver',
      'Value': 'Valor',
      'Status': 'Status',
      'Date': 'Data',

      'This order has already reached the limit of 5 cards.': 'Este pedido já atingiu o limite de 5 cartões.',
      'Continue': 'Continuar',
      'Confirmed amount:': 'Valor confirmado:',
      'Whose card is it?': 'De quem é o cartão?',
      'Mine': 'Meu',
      "Someone else's": 'De outra pessoa',
      'Full cardholder name': 'Nome completo do titular',
      "Cardholder's CPF": 'CPF do titular',
      'Number of Installments': 'Número de Parcelas',
      'Card Number': 'Número do Cartão',
      'Cardholder Name': 'Nome do Titular',
      'Expiration': 'Vencimento',
      'Month': 'Mês',
      'Year': 'Ano',
      'Security Code': 'Código de Segurança',
      'Pay': 'Pagar',
      'Please wait!': 'Aguarde!',
      'We are processing your payment!': 'Estamos processando o seu pagamento!',

      'Pending': 'Pendente',
      'Expired': 'Expirado',
      'Canceled': 'Cancelado',
      'Paid': 'Pago',
      'Approved': 'Aprovado',
      'Under Review': 'Em análise',
      'Declined': 'Recusado',

      'The order was paid successfully.': 'O pedido foi pago com sucesso.',
      'An error occurred while processing the payment, please try again.': 'Ocorreu um erro ao processar o pagamento, tente novamente.',
      'Unable to generate the pix, please try again.': 'Não foi possível gerar o pix, tente novamente.',
      'An error occurred, please try again.': 'Ocorreu um erro, tente novamente.',
      'This order is not available for payment or already paid.': 'Este pedido não está disponível para pagamento ou já foi pago.',
      'The amount entered is invalid.': 'O valor informado é inválido.',
      'The minimum amount per card is %amount%.': 'O valor mínimo por cartão é %amount%.',
      'Enter the full name and CPF of the cardholder.': 'Informe o nome completo e o CPF do titular do cartão.',
      'Unable to validate the cardholder.': 'Não foi possível validar o titular do cartão.',
      'The user was not found.': 'O usuário não foi encontrado.',
      'Unable to create the customer.': 'Não foi possível criar o cliente.',
      'The amount entered is no longer valid for this order.': 'O valor informado não é mais válido para este pedido.',
      'The payment was approved, but an error occurred while recording it. Please contact support.': 'O pagamento foi aprovado, mas ocorreu um erro ao registrá-lo. Entre em contato com o suporte.',
      'Please fill in all fields.': 'Por favor, preencha todos os campos.',
      'Cancel invoice': 'Cancelar fatura',
      'Payments made': 'Pagamentos realizados',
      'Cancel PIX': 'Cancelar PIX',
      'Card': 'Cartão',
      'Balance': 'Saldo',
      'The PIX has been canceled.': 'O PIX foi cancelado.',
      'Unable to cancel the PIX. It may have already been paid.': 'Não foi possível cancelar o PIX. Ele pode já ter sido pago.',
      'Confirm the cancellation of the PIX.': 'Confirme o cancelamento do PIX.',
      'Unable to cancel the PIX, please try again.': 'Não foi possível cancelar o PIX, tente novamente.',
      'Combo': 'Combo',
      'Method': 'Forma',
      'Account Balance': 'Saldo em Conta',
      'Your current balance is': 'Seu saldo atual é de',
      'and your balance after payment will be': 'e seu saldo após o pagamento será de',
      'Confirm': 'Confirmar',
      'You currently do not have enough balance to pay for this invoice.': 'No momento você não possui saldo suficiente para pagar esta fatura.',
      'The payment was made successfully.': 'O pagamento foi realizado com sucesso.',
      'You have no balance to pay for this order.': 'Você não possui saldo para pagar este pedido.',
      'Your payment was approved.': 'Seu pagamento foi aprovado.',
      'Your Tripteev access has been activated!': 'Seu acesso ao Tripteev foi ativado!',
    },
    es: {
      'Back': 'Volver',
      'We apologize, we are unable to retrieve the invoice at this time.': 'Lo sentimos, no podemos recuperar la factura en este momento.',
      'Try again': 'Intentar de nuevo',
      'The invoice was not found.': 'La factura no fue encontrada.',
      'Back to Tripteev': 'Volver a Tripteev',
      'Pay your invoice': 'Paga tu factura',
      'Choose the payment method. Access is released as soon as the payment is confirmed.': 'Elige la forma de pago. El acceso se libera en cuanto se confirme el pago.',
      'Invoice': 'Factura',
      'AWAITING PAYMENT': 'EN ESPERA DE PAGO',
      'Charge': 'Cobro',
      'Membership': 'Adhesión',
      'Monthly fee': 'Mensualidad',
      'Plan': 'Plan',
      'Access': 'Acceso',
      '30 days': '30 días',
      'Generated on': 'Generada el',
      'Expires on': 'Vence el',
      'Total': 'Total',
      'Total paid:': 'Total pagado:',
      'of': 'de',
      'Remaining:': 'Restante:',
      'Payment method': 'Forma de pago',
      'No payment method available at the moment. Please try again shortly.': 'No hay formas de pago disponibles en este momento. Inténtalo de nuevo en breve.',
      'Credit Card': 'Tarjeta de Crédito',
      'Payment received': 'Pago recibido',
      'We are activating your access. This takes a few moments.': 'Estamos activando tu acceso. Esto tarda unos instantes.',
      'Access activated!': '¡Acceso activado!',
      'Your Tripteev access is valid from': 'Tu acceso a Tripteev es válido del',
      'to': 'al',
      'or': 'o',
      'Sign in with your Nexteev username and password': 'Accede con tu usuario y contraseña de Nexteev',
      'Go to': 'Ir a',
      'Access the Tripteev portal': 'Acceder al portal Tripteev',
      'Invoice canceled': 'Factura cancelada',
      'This invoice has been canceled or has expired. Go back to Tripteev to generate a new one.': 'Esta factura fue cancelada o venció. Vuelve a Tripteev para generar una nueva.',

      'Amount to pay': 'Monto a pagar',
      'max:': 'máx:',
      'min:': 'mín:',
      'Generate Pix': 'Generar Pix',
      'Use the QR code to proceed with the transaction.': 'Usa el código QR para continuar con la transacción.',
      'Or use Pix Copy and Paste to proceed with the transaction.': 'O usa Pix Copiar y Pegar para continuar con la transacción.',
      'Use Pix Copy and Paste to proceed with the transaction.': 'Usa Pix Copiar y Pegar para continuar con la transacción.',
      'Copy Pix Copy and Paste': 'Copiar Pix Copiar y Pegar',
      'Copied to clipboard.': 'Copiado al portapapeles.',
      'Now, all you need to do is access your bank app and complete the process using Pix Copy and Paste.': 'Ahora, todo lo que necesitas hacer es acceder a la app de tu banco y completar el proceso usando Pix Copiar y Pegar.',
      'Waiting for payment confirmation…': 'Esperando la confirmación del pago…',
      'History': 'Historial',
      'View': 'Ver',
      'Value': 'Valor',
      'Status': 'Estado',
      'Date': 'Fecha',

      'This order has already reached the limit of 5 cards.': 'Este pedido ya alcanzó el límite de 5 tarjetas.',
      'Continue': 'Continuar',
      'Confirmed amount:': 'Monto confirmado:',
      'Whose card is it?': '¿De quién es la tarjeta?',
      'Mine': 'Mía',
      "Someone else's": 'De otra persona',
      'Full cardholder name': 'Nombre completo del titular',
      "Cardholder's CPF": 'CPF del titular',
      'Number of Installments': 'Número de Cuotas',
      'Card Number': 'Número de la Tarjeta',
      'Cardholder Name': 'Nombre del Titular',
      'Expiration': 'Vencimiento',
      'Month': 'Mes',
      'Year': 'Año',
      'Security Code': 'Código de Seguridad',
      'Pay': 'Pagar',
      'Please wait!': '¡Espera!',
      'We are processing your payment!': '¡Estamos procesando tu pago!',

      'Pending': 'Pendiente',
      'Expired': 'Expirado',
      'Canceled': 'Cancelado',
      'Paid': 'Pagado',
      'Approved': 'Aprobado',
      'Under Review': 'En revisión',
      'Declined': 'Rechazado',

      'The order was paid successfully.': 'El pedido se pagó con éxito.',
      'An error occurred while processing the payment, please try again.': 'Ocurrió un error al procesar el pago, inténtalo de nuevo.',
      'Unable to generate the pix, please try again.': 'No fue posible generar el pix, inténtalo de nuevo.',
      'An error occurred, please try again.': 'Ocurrió un error, inténtalo de nuevo.',
      'This order is not available for payment or already paid.': 'Este pedido no está disponible para pago o ya fue pagado.',
      'The amount entered is invalid.': 'El monto ingresado no es válido.',
      'The minimum amount per card is %amount%.': 'El monto mínimo por tarjeta es %amount%.',
      'Enter the full name and CPF of the cardholder.': 'Ingresa el nombre completo y el CPF del titular de la tarjeta.',
      'Unable to validate the cardholder.': 'No fue posible validar al titular de la tarjeta.',
      'The user was not found.': 'No se encontró el usuario.',
      'Unable to create the customer.': 'No fue posible crear el cliente.',
      'The amount entered is no longer valid for this order.': 'El monto ingresado ya no es válido para este pedido.',
      'The payment was approved, but an error occurred while recording it. Please contact support.': 'El pago fue aprobado, pero ocurrió un error al registrarlo. Ponte en contacto con soporte.',
      'Please fill in all fields.': 'Por favor, completa todos los campos.',
      'Cancel invoice': 'Cancelar factura',
      'Payments made': 'Pagos realizados',
      'Cancel PIX': 'Cancelar PIX',
      'Card': 'Tarjeta',
      'Balance': 'Saldo',
      'The PIX has been canceled.': 'El PIX fue cancelado.',
      'Unable to cancel the PIX. It may have already been paid.': 'No fue posible cancelar el PIX. Puede que ya haya sido pagado.',
      'Confirm the cancellation of the PIX.': 'Confirma la cancelación del PIX.',
      'Unable to cancel the PIX, please try again.': 'No fue posible cancelar el PIX, inténtalo de nuevo.',
      'Combo': 'Combo',
      'Method': 'Método',
      'Account Balance': 'Saldo en Cuenta',
      'Your current balance is': 'Tu saldo actual es de',
      'and your balance after payment will be': 'y tu saldo después del pago será de',
      'Confirm': 'Confirmar',
      'You currently do not have enough balance to pay for this invoice.': 'Actualmente no tienes saldo suficiente para pagar esta factura.',
      'The payment was made successfully.': 'El pago se realizó con éxito.',
      'You have no balance to pay for this order.': 'No tienes saldo para pagar este pedido.',
      'Your payment was approved.': 'Tu pago fue aprobado.',
      'Your Tripteev access has been activated!': '¡Tu acceso a Tripteev fue activado!',
    },
  },
  components: {
    Layout,
    Languages,
    EcosystemUserMenu,
  },
  directives: { money: VMoney },
  data() {
    return {
      logo: require("@/assets/images/brands/tripteev.svg"),
      loading: true,
      errored: false,
      message: "",
      timer: null,

      order: {
        id: this.$route.params.id,
        date: null,
        expires: null,
        total: "0.00",
        payment: {
          status: "pending",
          partial: "no",
          methods: {},
          list: [],
          paid: "0.00",
          remaining: "0.00",
          history: {
            creditcard: [],
            pix: [],
          },
        },
        tripteev: {
          type: "",
          status: "",
          name: "",
          date_start: null,
          date_end: null,
        },
      },

      balance: {
        loading: false,
        total: "0.00",
        valor: "0.00",
      },

      pix: {
        loading: false,
        canceling: false,
        valor: "0.00",
        text: "",
        image: "",
      },

      creditcard: {
        step: 1,
        loading: false,
        modal: false,
        ip: "",
        valor: "0.00",
        titular: "proprio",
        nome_completo: "",
        cpf: "",
        installments: [],
        installment: "1",
        number: "",
        expiryMonth: "",
        expiryYear: "",
        cvv: "",
        holderName: "",
      },

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
      },
    };
  },
  computed: {
    // URL do portal Tripteev com o token do usuário logado
    portal() {
      const token = localStorage.getItem("token");
      return "https://portal.tripteev.com/entrar/token/" + token;
    },
    // Pagamento parcial liberado pelo plano (adesão sem parcial sempre paga o total)
    partial() {
      return this.order.payment.partial == "yes";
    },
    progress() {
      const total = parseFloat(this.order.total || 0);
      if (total <= 0) {
        return 0;
      }
      return Math.min(100, (parseFloat(this.order.payment.paid || 0) / total) * 100);
    },
    creditcardMin() {
      const total = parseFloat(this.order.total || 0);
      const remaining = parseFloat(this.order.payment.remaining || 0);
      const pct = total * 0.2;
      return remaining < pct ? remaining : pct;
    },
    creditcardCount() {
      if (!this.order.payment.list || !this.order.payment.methods.creditcard) {
        return 0;
      }
      const name = this.order.payment.methods.creditcard.name;
      return this.order.payment.list.filter((item) => item.name === name).length;
    },
    // Sem parcial o saldo precisa cobrir o restante inteiro
    balanceAfter() {
      const valor = this.partial ? this.parseMoney(this.balance.valor) : parseFloat(this.order.payment.remaining || 0);
      return parseFloat(this.balance.total || 0) - valor;
    },
    hasMethods() {
      return this.order.payment.methods && Object.keys(this.order.payment.methods).length > 0;
    },
  },
  methods: {
    getOrder(silent) {
      if (!this.order.id) {
        return;
      }

      api
        .get("tripteev/order/" + this.order.id)
        .then((response) => {
          if (!response.data || typeof response.data !== "object") {
            if (!silent) {
              this.errored = true;
            }
            return;
          }

          if (response.data.status == "success") {
            const remaining = this.order.payment.remaining;
            const wasActive = this.order.tripteev.status == "approved";

            this.order = response.data.order;
            this.errored = false;

            // Só reinicia os formulários quando o valor restante mudou (novo pagamento)
            if (!silent || remaining != this.order.payment.remaining) {
              this.pix.valor = this.$options.filters.currency(this.order.payment.remaining);
              this.creditcard.valor = this.$options.filters.currency(this.order.payment.remaining);
              this.balance.valor = this.$options.filters.currency(this.order.payment.remaining);
              this.creditcard.step = 1;
              this.pix.text = "";
              this.pix.image = "";

              const pendingPix = (this.order.payment.history.pix || []).find((row) => row.status === "pending");
              if (this.order.payment.status == "pending" && pendingPix) {
                this.pix.valor = this.$options.filters.currency(pendingPix.value);
                this.gerarPix();
              }
            }

            if (!silent && this.order.payment.status == "pending") {
              this.getBalance();
            }

            // Aprovado durante a consulta automática
            if (silent && !wasActive && this.order.tripteev.status == "approved") {
              this.$toast.success(this.t("Your Tripteev access has been activated!"));
            }

            this.schedule();
          } else {
            this.message = response.data.message || "The invoice was not found.";
          }
        })
        .catch(() => {
          if (!silent) {
            this.errored = true;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // Enquanto aguarda o pagamento ou a ativação, consulta a fatura a cada 10 segundos
    schedule() {
      clearTimeout(this.timer);
      const waiting = this.order.payment.status == "pending" || (this.order.payment.status == "approved" && this.order.tripteev.status != "approved");
      if (waiting) {
        this.timer = setTimeout(() => this.getOrder(true), 10000);
      }
    },
    parseMoney(value) {
      if (!value) {
        return 0;
      }
      return parseFloat(String(value).replace(/[^\d,-]/g, "").replace(",", ".")) || 0;
    },
    getBalance() {
      api.get("wallet/balance/network").then((response) => {
        if (response.data.status == "success") {
          this.balance.total = response.data.balance;
        }
      });
    },
    payBalance() {
      this.balance.loading = true;

      api
        .post("wallet/pay/" + this.order.id, {
          valor: this.amount(this.balance.valor),
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success(this.t("The payment was made successfully."));
            this.getOrder();
          } else {
            this.$toast.error(this.t(response.data.message));
          }
        })
        .catch(() => {
          this.$toast.error(this.t("An error occurred while processing the payment, please try again."));
        })
        .finally(() => {
          this.balance.loading = false;
        });
    },
    // Sem parcial o valor não é enviado: a API cobra o restante
    amount(value) {
      return this.partial ? value : "";
    },
    gerarPix() {
      this.pix.loading = true;

      api
        .post("store/orders/" + this.order.id + "/pix", {
          valor: this.amount(this.pix.valor),
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.pix.text = response.data.pix.text;
            this.pix.image = response.data.pix.image;
          } else {
            this.$toast.error(this.t(response.data.message));
          }
        })
        .catch(() => {
          this.$toast.error(this.t("Unable to generate the pix, please try again."));
        })
        .finally(() => {
          this.pix.loading = false;
        });
    },
    creditCardVoltar() {
      this.creditcard.step = this.creditcard.step - 1;
    },
    creditCardEscolherTitular() {
      this.creditcard.step = 2;
    },
    creditCardConfirmarTitular() {
      this.creditcard.loading = true;

      api
        .post("store/orders/" + this.order.id + "/creditcard/installments", {
          valor: this.amount(this.creditcard.valor),
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.creditcard.installments = response.data.installments;
            this.creditcard.step = 3;
          } else {
            let message = this.t(response.data.message);
            if (response.data.amount) message = message.replace("%amount%", response.data.amount);
            this.$toast.error(message);
          }
        })
        .catch(() => {
          this.$toast.error(this.t("An error occurred, please try again."));
        })
        .finally(() => {
          this.creditcard.loading = false;
        });
    },
    payCreditCard() {
      this.creditcard.loading = true;
      this.creditcard.modal = true;

      api
        .post("store/orders/" + this.order.id + "/creditcard", {
          valor: this.amount(this.creditcard.valor),
          titular: this.creditcard.titular,
          nome_completo: this.creditcard.nome_completo,
          cpf: this.creditcard.cpf,
          installment: this.creditcard.installment,
          number: this.creditcard.number,
          holderName: this.creditcard.holderName,
          expiryMonth: this.creditcard.expiryMonth,
          expiryYear: this.creditcard.expiryYear,
          cvv: this.creditcard.cvv,
          ip: this.creditcard.ip,
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success(this.t("The order was paid successfully."));
            this.creditcard.step = 1;
            this.getOrder();
          } else {
            let message = this.t(response.data.message);
            if (response.data.amount) message = message.replace("%amount%", response.data.amount);
            this.$toast.error(message);
          }
        })
        .catch(() => {
          this.$toast.error(this.t("An error occurred while processing the payment, please try again."));
        })
        .finally(() => {
          this.creditcard.loading = false;
          this.creditcard.modal = false;
        });
    },
    // Cancela o PIX gerado (no Asaas e localmente) e volta para gerar outro
    cancelPix() {
      this.pix.canceling = true;

      api
        .post("tripteev/order/" + this.order.id + "/pix/cancel", { confirm: "yes" })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success(this.t(response.data.message));
            this.pix.text = "";
            this.pix.image = "";
            this.pix.valor = this.$options.filters.currency(this.order.payment.remaining);
          } else {
            this.$toast.error(this.t(response.data.message));
          }
        })
        .catch(() => {
          this.$toast.error(this.t("Unable to cancel the PIX, please try again."));
        })
        .finally(() => {
          this.pix.canceling = false;
        });
    },
    copied() {
      this.$toast.success("<strong>" + this.t("Copied to clipboard.") + "</strong><br>" + this.t("Now, all you need to do is access your bank app and complete the process using Pix Copy and Paste."));
    },
    cardStatusLabel(status) {
      const labels = {
        RECEIVED: this.t("Approved"),
        CONFIRMED: this.t("Approved"),
        PENDING: this.t("Pending"),
        AWAITING_RISK_ANALYSIS: this.t("Under Review"),
      };
      return labels[status] || this.t("Declined");
    },
    getIp() {
      fetch("https://api.ipify.org?format=json")
        .then((response) => response.json())
        .then((data) => {
          if (data.ip) {
            this.creditcard.ip = data.ip;
          }
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getOrder();
    this.getIp();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>

<template>
  <Layout>
    <div class="ecosystem">
      <header class="ecosystem-header">
        <router-link to="/tripteev" class="ecosystem-back">
          <i class="bx bx-left-arrow-alt" aria-hidden="true"></i> {{ t('Back to Tripteev') }}
        </router-link>
        <div class="ecosystem-actions">
          <Languages type="right"></Languages>
          <EcosystemUserMenu></EcosystemUserMenu>
        </div>
      </header>

      <main class="ecosystem-main">
        <div class="tripteev">
          <div v-if="loading" class="text-center py-5">
            <b-spinner variant="default" role="status"></b-spinner>
          </div>
          <div v-else-if="errored" class="tripteev-box text-center">
            <p>{{ t('We apologize, we are unable to retrieve the invoice at this time.') }}</p>
            <button class="btn btn-default" v-on:click="loading = true; errored = false; getOrder()">{{ t('Try again') }}</button>
          </div>
          <div v-else-if="message" class="tripteev-box text-center">
            <p>{{ t(message) }}</p>
            <router-link to="/tripteev" class="btn btn-default">{{ t('Back to Tripteev') }}</router-link>
          </div>

          <!-- Pago -->
          <div v-else-if="order.payment.status == 'approved'" class="tripteev-box tripteev-result text-center">
            <template v-if="order.tripteev.status == 'approved'">
              <img :src="logo" alt="Tripteev" class="tripteev-logo" />
              <i class="bx bx-check-circle tripteev-result-icon" aria-hidden="true"></i>
              <h1 class="tripteev-title">{{ t('Access activated!') }}</h1>
              <p class="tripteev-subtitle mb-4">{{ t('Your Tripteev access is valid from') }} {{ order.tripteev.date_start }} {{ t('to') }} {{ order.tripteev.date_end }}.</p>
              <a :href="portal" target="_blank" rel="noopener" class="btn btn-default btn-lg btn-block text-uppercase mb-2">
                {{ t('Access the Tripteev portal') }} <i class="bx bx-link-external ml-1 align-middle" aria-hidden="true"></i>
              </a>
              <p class="text-center text-muted my-2">{{ t('or') }}</p>
              <p class="text-center mb-2">{{ t('Sign in with your Nexteev username and password') }}</p>
              <a href="https://portal.tripteev.com" target="_blank" rel="noopener" class="btn btn-outline-default btn-lg btn-block">
                {{ t('Go to') }} portal.tripteev.com <i class="bx bx-link-external ml-1 align-middle" aria-hidden="true"></i>
              </a>
              <router-link to="/tripteev" class="btn btn-link btn-block mt-3">{{ t('Back to Tripteev') }}</router-link>
            </template>
            <template v-else>
              <img :src="logo" alt="Tripteev" class="tripteev-logo" />
              <b-spinner variant="default" role="status"></b-spinner>
              <h1 class="tripteev-title mt-3">{{ t('Payment received') }}</h1>
              <p class="tripteev-subtitle mb-0">{{ t('We are activating your access. This takes a few moments.') }}</p>
            </template>
          </div>

          <!-- Cancelada ou expirada -->
          <div v-else-if="order.payment.status == 'canceled'" class="tripteev-box tripteev-result text-center">
            <img :src="logo" alt="Tripteev" class="tripteev-logo" />
            <i class="bx bx-x-circle tripteev-result-icon" aria-hidden="true"></i>
            <h1 class="tripteev-title">{{ t('Invoice canceled') }}</h1>
            <p class="tripteev-subtitle mb-4">{{ t('This invoice has been canceled or has expired. Go back to Tripteev to generate a new one.') }}</p>
            <router-link to="/tripteev" class="btn btn-default btn-lg btn-block text-uppercase">{{ t('Back to Tripteev') }}</router-link>
          </div>

          <!-- Aguardando pagamento -->
          <template v-else>
            <div class="tripteev-intro">
              <img :src="logo" alt="Tripteev" class="tripteev-logo" />
              <h1 class="tripteev-title">{{ t('Pay your invoice') }}</h1>
              <p class="tripteev-subtitle">{{ t('Choose the payment method. Access is released as soon as the payment is confirmed.') }}</p>
            </div>

            <div class="tripteev-confirm">
            <div class="tripteev-box tripteev-summary">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <h5 class="mb-0">{{ t('Invoice') }} #{{ order.id }}</h5>
                <span class="badge badge-soft-danger font-size-12">{{ t('AWAITING PAYMENT') }}</span>
              </div>
              <dl>
                <div>
                  <dt>{{ t('Charge') }}</dt>
                  <dd>{{ order.tripteev.type == 'adhesion' ? t('Membership') : t('Monthly fee') }}</dd>
                </div>
                <div v-if="order.tripteev.combo">
                  <dt>{{ t('Combo') }}</dt>
                  <dd>{{ order.tripteev.combo }}</dd>
                </div>
                <div>
                  <dt>{{ t('Access') }}</dt>
                  <dd>{{ t('30 days') }}</dd>
                </div>
                <div>
                  <dt>{{ t('Generated on') }}</dt>
                  <dd>{{ order.date }}</dd>
                </div>
                <div v-if="parseFloat(order.payment.paid) <= 0">
                  <dt>{{ t('Expires on') }}</dt>
                  <dd>{{ order.expires }}</dd>
                </div>
                <div class="is-total">
                  <dt>{{ t('Total') }}</dt>
                  <dd>{{ order.total | currency }}</dd>
                </div>
              </dl>

              <router-link v-if="parseFloat(order.payment.paid) <= 0" to="/tripteev/cancel" class="btn btn-outline-danger btn-lg btn-block text-uppercase mt-3">
                {{ t('Cancel invoice') }}
              </router-link>
            </div>


            <div class="tripteev-box">
              <h5 class="mb-0">{{ t('Payment method') }}</h5>
              <p v-if="!hasMethods" class="text-muted mt-3 mb-0">
                {{ t('No payment method available at the moment. Please try again shortly.') }}
              </p>
              <b-tabs v-else justified nav-class="nav-tabs-custom mt-2" content-class="pt-3">
                <!-- PIX -->
                <b-tab v-if="order.payment.methods.pix">
                  <template v-slot:title>PIX</template>

                  <div v-if="pix.text" class="text-center">
                    <div v-if="pix.image">
                      <p class="mb-3">{{ t('Use the QR code to proceed with the transaction.') }}</p>
                      <div class="mb-3 d-flex justify-content-center">
                        <div class="border rounded p-3">
                          <img style="width: 180px; max-width: 100%" :src="'data:image/png;base64,' + pix.image" />
                        </div>
                      </div>
                      <p>{{ t('Or use Pix Copy and Paste to proceed with the transaction.') }}</p>
                    </div>
                    <p v-else>{{ t('Use Pix Copy and Paste to proceed with the transaction.') }}</p>
                    <fieldset class="text-break py-3 mb-3">{{ pix.text }}</fieldset>
                    <button class="btn btn-default btn-lg btn-block text-uppercase" v-clipboard:copy="pix.text" v-on:click="copied()">
                      {{ t('Copy Pix Copy and Paste') }}
                    </button>
                    <button class="btn btn-outline-danger btn-lg btn-block text-uppercase mt-2" :disabled="pix.canceling" v-on:click="cancelPix()">
                      {{ t('Cancel PIX') }}
                      <b-spinner v-if="pix.canceling" small class="ml-2 align-middle" variant="danger" role="status"></b-spinner>
                    </button>
                    <p class="text-muted mt-3 mb-0">
                      <b-spinner small class="mr-1 align-middle" variant="default" role="status"></b-spinner>
                      {{ t('Waiting for payment confirmation…') }}
                    </p>
                  </div>
                  <div v-else>
                    <b-form-group v-if="partial" :label="t('Amount to pay')" label-for="pix-valor">
                      <b-form-input id="pix-valor" v-model="pix.valor" v-money="money" type="text" inputmode="decimal"></b-form-input>
                      <small class="text-muted">{{ t('max:') }} {{ order.payment.remaining | currency }}</small>
                    </b-form-group>
                    <p v-else class="text-center">{{ t('Amount to pay') }}: <strong>{{ order.payment.remaining | currency }}</strong></p>
                    <button class="btn btn-default btn-lg btn-block text-uppercase" :disabled="pix.loading" v-on:click="gerarPix()">
                      {{ t('Generate Pix') }}
                      <b-spinner v-if="pix.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                    </button>
                  </div>
                </b-tab>

                <!-- Cartão de crédito -->
                <b-tab v-if="order.payment.methods.creditcard">
                  <template v-slot:title>{{ t('Card') }}</template>

                  <div v-if="creditcardCount >= 5" class="text-center py-3">
                    {{ t('This order has already reached the limit of 5 cards.') }}
                  </div>
                  <template v-else>
                    <div v-if="creditcard.step == 1">
                      <b-form-group v-if="partial" :label="t('Amount to pay')" label-for="creditcard-valor">
                        <b-form-input id="creditcard-valor" v-model="creditcard.valor" v-money="money" type="text" inputmode="decimal"></b-form-input>
                        <small class="text-muted">{{ t('max:') }} {{ order.payment.remaining | currency }}, {{ t('min:') }} {{ creditcardMin | currency }}</small>
                      </b-form-group>
                      <p v-else class="text-center">{{ t('Amount to pay') }}: <strong>{{ order.payment.remaining | currency }}</strong></p>
                      <button class="btn btn-default btn-lg btn-block text-uppercase" v-on:click="creditCardEscolherTitular()">
                        {{ t('Continue') }}
                      </button>
                    </div>

                    <div v-else-if="creditcard.step == 2">
                      <p>{{ t('Confirmed amount:') }} <strong>{{ partial ? creditcard.valor : $options.filters.currency(order.payment.remaining) }}</strong></p>
                      <b-form-group :label="t('Whose card is it?')">
                        <b-form-radio-group v-model="creditcard.titular" :options="[{ text: t('Mine'), value: 'proprio' }, { text: t('Someone else\'s'), value: 'terceiro' }]"></b-form-radio-group>
                      </b-form-group>
                      <template v-if="creditcard.titular == 'terceiro'">
                        <b-form-group :label="t('Full cardholder name')" label-for="nome_completo">
                          <b-form-input id="nome_completo" v-model="creditcard.nome_completo" type="text" required></b-form-input>
                        </b-form-group>
                        <b-form-group :label="t('Cardholder\'s CPF')" label-for="cpf">
                          <b-form-input id="cpf" v-model="creditcard.cpf" type="text" required v-mask="'###.###.###-##'"></b-form-input>
                        </b-form-group>
                      </template>
                      <button class="btn btn-default btn-lg btn-block text-uppercase mb-2" :disabled="creditcard.loading" v-on:click="creditCardConfirmarTitular()">
                        {{ t('Continue') }}
                        <b-spinner v-if="creditcard.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                      </button>
                      <button class="btn btn-outline-dark btn-lg btn-block text-uppercase" v-on:click="creditCardVoltar()">{{ t('Back') }}</button>
                    </div>

                    <b-form v-else @submit.prevent="payCreditCard">
                      <b-form-group :label="t('Number of Installments')" label-for="installment">
                        <b-form-select id="installment" v-model="creditcard.installment" :options="creditcard.installments" required></b-form-select>
                      </b-form-group>
                      <b-form-group :label="t('Card Number')" label-for="number">
                        <b-form-input id="number" v-model="creditcard.number" type="text" inputmode="numeric" autocomplete="cc-number" required v-mask="'#### #### #### ####'"></b-form-input>
                      </b-form-group>
                      <b-form-group :label="t('Cardholder Name')" label-for="holderName">
                        <b-form-input id="holderName" v-model="creditcard.holderName" type="text" autocomplete="cc-name" required></b-form-input>
                      </b-form-group>
                      <div class="row">
                        <div class="col-12 col-md-6">
                          <b-form-group :label="t('Expiration')" label-for="expiryMonth">
                            <b-input-group>
                              <b-form-input id="expiryMonth" v-model="creditcard.expiryMonth" type="text" inputmode="numeric" :placeholder="t('Month')" maxlength="2" required v-mask="'##'"></b-form-input>
                              <b-form-input id="expiryYear" v-model="creditcard.expiryYear" type="text" inputmode="numeric" :placeholder="t('Year')" maxlength="2" required v-mask="'##'"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </div>
                        <div class="col-12 col-md-6">
                          <b-form-group :label="t('Security Code')" label-for="cvv">
                            <b-form-input id="cvv" v-model="creditcard.cvv" type="text" inputmode="numeric" autocomplete="cc-csc" required v-mask="'###'"></b-form-input>
                          </b-form-group>
                        </div>
                      </div>
                      <button class="btn btn-default btn-lg btn-block text-uppercase mb-2" type="submit" :disabled="creditcard.loading">
                        {{ t('Pay') }}
                        <b-spinner v-if="creditcard.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                      </button>
                      <button class="btn btn-outline-dark btn-lg btn-block text-uppercase" type="button" v-on:click="creditCardVoltar()">{{ t('Back') }}</button>
                    </b-form>

                    <div v-if="order.payment.history.creditcard.length > 0" class="mt-4">
                      <h6>{{ t('History') }}</h6>
                      <div class="table-responsive">
                        <table class="table table-sm table-nowrap mb-0">
                          <thead class="thead-light">
                            <tr>
                              <th>{{ t('Value') }}</th>
                              <th>{{ t('Status') }}</th>
                              <th>{{ t('Date') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, index) in order.payment.history.creditcard" :key="index">
                              <td>{{ row.value | currency }}</td>
                              <td>{{ cardStatusLabel(row.status) }}</td>
                              <td>{{ row.date }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </template>
                </b-tab>

                <!-- Saldo em conta -->
                <b-tab key="balance">
                  <template v-slot:title>{{ t('Balance') }}</template>

                  <template v-if="balance.total > 0">
                    <b-form-group v-if="partial" :label="t('Amount to pay')" label-for="balance-valor">
                      <b-form-input id="balance-valor" v-model="balance.valor" v-money="money" type="text" inputmode="decimal"></b-form-input>
                      <small class="text-muted">{{ t('max:') }} {{ order.payment.remaining | currency }}</small>
                    </b-form-group>
                    <p v-else class="text-center">{{ t('Amount to pay') }}: <strong>{{ order.payment.remaining | currency }}</strong></p>
                    <p>{{ t('Your current balance is') }} <strong>{{ balance.total | currency }}</strong> {{ t('and your balance after payment will be') }} <strong>{{ balanceAfter | currency }}</strong>.</p>
                    <button class="btn btn-default btn-lg btn-block text-uppercase" :disabled="balance.loading || balanceAfter < 0" v-on:click="payBalance()">
                      {{ t('Confirm') }}
                      <b-spinner v-if="balance.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
                    </button>
                  </template>
                  <p v-else class="text-center mb-0">{{ t('You currently do not have enough balance to pay for this invoice.') }}</p>
                </b-tab>
              </b-tabs>
            </div>
            </div>
            <!-- Pagamentos já realizados (pagamento parcial) -->
            <div v-if="order.payment.list.length > 0" class="tripteev-box mt-3 mt-lg-4">
              <h5 class="mb-3">{{ t('Payments made') }}</h5>
              <div class="d-flex justify-content-between flex-wrap">
                <div>{{ t('Total paid:') }} <strong>{{ order.payment.paid | currency }}</strong> {{ t('of') }} <strong>{{ order.total | currency }}</strong></div>
                <div>{{ t('Remaining:') }} <strong>{{ order.payment.remaining | currency }}</strong></div>
              </div>
              <b-progress :value="progress" max="100" class="mt-2 mb-4"></b-progress>
              <div class="table-responsive">
                <table class="table table-sm table-nowrap mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th>{{ t('Method') }}</th>
                      <th>{{ t('Value') }}</th>
                      <th>{{ t('Date') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(pay, index) in order.payment.list" :key="index">
                      <td>{{ pay.name }}</td>
                      <td>{{ pay.value | currency }}</td>
                      <td>{{ pay.date }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
        </div>
      </main>
    </div>

    <b-modal v-model="creditcard.modal" modal-class="modal-center" hide-header hide-footer centered no-close-on-backdrop no-close-on-esc>
      <div class="text-center py-4">
        <div class="d-flex justify-content-center align-items-center mb-4">
          <b-spinner large class="align-middle" variant="default" role="status"></b-spinner>
        </div>
        <h5>{{ t('Please wait!') }}</h5>
        <h6>{{ t('We are processing your payment!') }}</h6>
      </div>
    </b-modal>
  </Layout>
</template>
